<template>
    <div class="loggi-message">
        <p><span v-text="$ml.get('loggiThanksMessage')" /><span>{{ firstName | capitalize }}</span></p>
        <p class="loggi-success-title text-center my-4" v-text="$ml.get('loggiSuccessTitle')" />
        <p>
            <span v-text="$ml.get('loggiSuccessBody')" />
            <span class="d-block">{{ getSubmitModel.Guest.Email }}.</span>
        </p>
        <div class="my-4">
            <span v-text="$ml.get('requestNumber')" />:
            <span class="d-block font-weight-bold">{{ OrderNumber }}</span>
        </div>
    </div>
</template>

<script>
    import { mapGetters,mapState } from 'vuex';

export default {
    name:'LoggiMessage',
    computed:{
        ...mapState('preorder', [
            'OrderNumber'
        ]),
        ...mapGetters({
            getSubmitModel:'customer/getSubmitModel'
        }),
        firstName() {
            const [ name = '' ] = this.getSubmitModel
            .Guest
            .FullName
            .split(' ');
            return name; 
        },
    }
};
</script>

<style lang="scss" scoped>
    .loggi-message {
        text-align: center;

        .loggi-success-title {
            color: #43B977;
            font-weight: bold;
        }
    }
</style>